import RoomIndexVue from "@/views/room/RoomIndex.vue";

const room = [
    {
        path: '/room',
        name: 'room',
        component: RoomIndexVue
    }
]

export default room;